import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default ({
  namespaced: true,
  state: {
    caseTrend: {
      trend: {}
    },
    caseTrends: []
  },
  mutations: {
    CASE_TREND(state, caseTrend) {
      state.caseTrend = caseTrend
    },
    CASE_TRENDS(state, caseTrends) {
      state.caseTrends = caseTrends
    }
  },
  getters: {
    getCaseTrend(state) {
      return state.caseTrend
    },
    getCaseTrends(state) {
      return state.caseTrends
    }
  },
  actions: {
    saveTrend(context, caseTrend) {
      let formData = new FormData()

      Object.keys(caseTrend).forEach((item, i) => {
        if (typeof caseTrend[item] === 'object') {
          formData.append(item, JSON.stringify(caseTrend[item]))
        } else if (caseTrend[item] && caseTrend[item].toString().length) {
          formData.append(item, caseTrend[item])
        }
      });

      Vue.axios.post('/api/caseTrend/save', formData).then(() => {
        context.dispatch('petra/trends/loadTrends', caseTrend.caseID, {
          root: true
        })
      })
    },
    loadCaseTrends(context, caseID) {
      Vue.axios.get('/api/caseTrend/list', {
        params: {
          caseID: caseID
        }
      }).then((res) => {
        context.commit('CASE_TRENDS', JSON.parse(res.data))
      })
    },
    clearTrend(context) {
      context.commit('CASE_TREND', {
        trend: {}
      })
    },
    loadCaseTrend(context, trendId) {
      Vue.axios.get('/api/caseTrend/load', {
        params: {
          id: trendId
        }
      }).then((res) => {
        context.commit('CASE_TREND', JSON.parse(res.data))
      })
    }
  }
})